import { QueryClient } from 'react-query';
import { logger } from '@sentry/react';
import { waitUntilIdle } from 'utils/api';

export const handleControllerChange = (queryClient: QueryClient) => {
  // Delay reload to allow the pending network requests to complete
  setTimeout(() => {
    void (async () => {
      // Making sure all queries are idle before reloading
      await waitUntilIdle(queryClient);

      logger.warn(
        'New Service Worker has taken control. Reloading page to apply update and prevent mismatch errors.'
      );

      window.location.reload();
    })();
  }, 500);
};

export const listenToSWControllerChange = (queryClient: QueryClient) => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.addEventListener('controllerchange', () =>
      handleControllerChange(queryClient)
    );
  }
};
